// @ts-nocheck
import productDetailsReducer, {
    BunzlPagesProductDetailsActions,
} from "@store/Framework/Store/Bunzl/Pages/ProductDetails/ProductDetailsReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    productDetails: productDetailsReducer,
};

export type BunzlPagesActions = BunzlPagesProductDetailsActions;
export default combineReducers(pagesReducers);
